var process = require("./shim/process.js");
module.exports.isNode =
  process !== undefined &&
  process.release !== undefined &&
  process.release.name.search(/node|io.js/) !== -1;
module.exports.isProd = module.exports.isNode
  ? !!process.env.IS_PROD
  : location.hostname !== "127.0.0.1" &&
    location.hostname !== "localhost" &&
    !location.hostname.startsWith("192.168.");
module.exports.prodSchemes = [
  "krunker_prod",
  "krunker_comp",
  "krunker_social",
  "krunker_api",
  "krunker_matchmaker",
  "krunker_file_server",
];
module.exports.compSchemes = ["krunker_comp", "krunker_comp_beta"];
module.exports.socialBetaSchemes = ["krunker_social_beta"];
module.exports.prodURLs = ["krunker.io", "comp.krunker.io"];
module.exports.compURLs = ["comp.krunker.io", "comp_beta.krunker.io"];
module.exports.socialBetaURLs = ["social_beta.krunker.io"];
if (module.exports.isNode) {
  module.exports.isProdScheme =
    module.exports.prodSchemes.indexOf(process.env.VULTR_SCHEME) != -1;
  module.exports.isComp =
    module.exports.compSchemes.indexOf(process.env.VULTR_SCHEME) != -1;
  module.exports.isSocialBeta =
    module.exports.socialBetaSchemes.indexOf(process.env.VULTR_SCHEME) != -1;
} else {
  module.exports.isProdScheme =
    module.exports.prodURLs.indexOf(location.hostname) != -1;
  module.exports.isComp =
    module.exports.compURLs.indexOf(location.hostname) != -1;
  module.exports.isSocialBeta =
    module.exports.socialBetaURLs.indexOf(location.hostname) != -1;
}
var f = module.exports.isComp;
module.exports.alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
module.exports.enableHttps =
  module.exports.isProd ||
  (!module.exports.isNode && localStorage.__FORCE_HTTPS__ == "true");
module.exports.serverTickFrequency = 30;
module.exports.serverTickRate = 1000 / module.exports.serverTickFrequency;
module.exports.clientSendRate = 1000 / 30;
module.exports.dltMx = Math.round(1000 / 30);
module.exports.streamUpdate = 10000;
module.exports.maxPlayers = 8;
module.exports.serverSpread = 3;
module.exports.gamesPerServer = f ? 1 : 2;
module.exports.serverBrowserRate = 10000;
module.exports.maxPlayersTotal =
  module.exports.maxPlayers * module.exports.gamesPerServer + 40;
module.exports.kickTimer = 90000;
module.exports.maxPayloadLength = 750000;
module.exports.useLooseClient = false;
module.exports.movDirs = [];
for (var g = 0; g < 8; ++g) {
  module.exports.movDirs.push(-Math.PI + ((g + 1) * Math.PI) / 4);
}
module.exports.interpolation = f ? 1.5 : 1.1;
module.exports.stateHistory = 500;
module.exports.syncFrequency = 1;
module.exports.syncRate = 1000 / module.exports.syncFrequency;
module.exports.recaptchaKey = "6LdvBrQUAAAAAL6gtEpVNzii_3nQkbOyx912nvlm";
module.exports.pingCount = 10;
module.exports.maxObfPing = 100;
module.exports.maxObfPad = 55;
module.exports.minObfPad = 20;
module.exports.minKDFLvl = 50;
module.exports.minKDFCall = 25;
module.exports.maxKPDCalls = 10;
module.exports.kpdCallTime = 10;
if (module.exports.isProd) {
  if (module.exports.isProdScheme) {
    module.exports.matchmakerURL = "https://matchmaker.krunker.io";
    module.exports.apiURL = "https://api.krunker.io";
    module.exports.socialURL = "https://social.krunker.io";
  } else {
    // module.exports.matchmakerURL = "https://matchmaker_beta.krunker.io";
    // module.exports.apiURL = "https://api_beta.krunker.io";
    // module.exports.socialURL = "https://social_beta.krunker.io

    module.exports.matchmakerURL = "https://totallynotio.krunker.zip";
    module.exports.apiURL = "https://totallynotio.krunker.zip";
    module.exports.socialURL = "https://totallynotio.krunker.zip/social";
  }
} else {
  // module.exports.matchmakerURL = "http://127.0.0.1:5050";
  // module.exports.apiURL = "http://127.0.0.1:5060";
  // module.exports.socialURL = "http://127.0.0.1:5070";
  module.exports.matchmakerURL = "http://127.0.0.1:6767";
  module.exports.apiURL = "http://127.0.0.1:6767";
  module.exports.socialURL = "http://127.0.0.1:6767/social";
}
module.exports.availableRegions = module.exports.isProd
  ? module.exports.isComp
    ? ["sgp", "de-fra", "us-nj"]
    : [
        "de-fra",
        "us-ca-sv",
        "au-syd",
        "jb-hnd",
        "us-fl",
        "sgp",
        "us-nj",
        "blr",
        "us-tx",
        "brz",
        "me-bhn",
        "af-ct",
      ]
  : ["local"];
module.exports.partnerPReq = 150000;
module.exports.regionIND = {
  sgp: 2,
  "jb-hnd": 2,
  "us-nj": 4,
  "us-fl": 4,
  "us-ca-sv": 4,
  brz: 4,
  "us-tx": 4,
  "au-syd": 1,
  "de-fra": 3,
  blr: 2,
  "me-bhn": 2,
};
module.exports.shopTabs = [
  "Prize Wheels",
  "Premium",
  "Purchase KR",
  "Redeem",
  "Marketplace",
];
module.exports.currentSeason = 3;
module.exports.easterEggs = 150;
module.exports.eggReward = 5000;
module.exports.angels = [];
module.exports.buM9 = [
  "selaphiel",
  "uriel",
  "jophiel",
  "michael",
  "tabellarium",
  "purgatory",
];
module.exports.tradeMinLvl = 20;
module.exports.tradeCost = 10;
module.exports.tradeMaxOut = 5;
module.exports.tradeMaxOutP = 10;
module.exports.interactTradeTimer = 3000;
module.exports.rewardTime = 21600000;
module.exports.rewardMinLvl = 5;
module.exports.chalVar = 0.03;
module.exports.maxChal = 26;
module.exports.minChalLevel = 30;
module.exports.rankVar = 0.03;
module.exports.eloPer = 120;
module.exports.eloK = 32;
module.exports.queues = [
  {
    id: "r1v1",
    name: "windows.ranked.mode.r1v1",
    maxPartySize: 1,
    key: "elo",
  },
  {
    id: "r2v2",
    name: "windows.ranked.mode.r2v2",
    defaultQueue: true,
    maxPartySize: 2,
    key: "elo2",
  },
  {
    id: "r4v4",
    name: "windows.ranked.mode.r4v4",
    maxPartySize: 4,
    key: "elo4",
  },
];
module.exports.minRankedLevel = 15;
module.exports.rankedCooldown = 7200000;
module.exports.rankedDeduction = 30;
module.exports.endTimer = 25000;
module.exports.endAnim = 5000;
module.exports.voteKickReq = 4;
module.exports.voteKickMaxLvl = 10;
module.exports.voteKickTimer = 35000;
module.exports.inpDirGran = 30;
module.exports.inpBackTim = 3000;
module.exports.thrdPZ = 14;
module.exports.thrdPX = 5;
module.exports.serverConfig = [
  {
    name: "Players",
    varN: "maxPlayers",
    def: 2,
    max: 10,
    maxP: 16,
    maxF: 20,
    maxG: 6,
    min: 1,
    step: 1,
  },
  {
    name: "Min Players",
    varN: "minPlayers",
    def: 0,
    max: 10,
    maxP: 16,
    maxF: 20,
    maxG: 6,
    min: 0,
    step: 1,
  },
  {
    name: "Minutes",
    varN: "gameTime",
    def: 4,
    max: 60,
    min: 0,
    step: 1,
  },
  {
    name: "Warmup",
    varN: "warmupTime",
    def: 0,
    max: 4,
    min: 0,
    step: 0.1,
  },
  {
    name: "Auto Respawn",
    varN: "forceSpawn",
    def: 0,
    max: 15,
    min: 0,
    step: 1,
  },
  {
    name: "Lives",
    varN: "lives",
    def: 0,
    max: 10,
    min: 0,
    step: 1,
  },
  {
    name: "Score Limit",
    varN: "scoreLimit",
    def: 0,
    max: 10000,
    min: 0,
    step: 100,
  },
  {
    name: "40 Player Server",
    head: "Server Upgrades",
    varN: "maxPS",
    cost: 1000,
    def: false,
    bool: true,
  },
  {
    name: "Promote Server",
    varN: "promServ",
    cost: 500,
    def: false,
    bool: true,
  },
  {
    name: "Gravity",
    head: "Physics",
    varN: "gravMlt",
    dontChange: true,
    def: 1,
    max: 2,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Jump Force",
    varN: "jumpMlt",
    dontChange: true,
    def: 1,
    max: 3,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Time Scale",
    varN: "deltaMlt",
    dontChange: true,
    def: 1,
    max: 1.5,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Slide Time",
    varN: "slidTime",
    dontChange: true,
    def: 1,
    max: 5,
    min: 1,
    step: 0.1,
  },
  {
    name: "Weapon Impulse",
    varN: "impulseMlt",
    dontChange: true,
    def: 1,
    max: 3,
    min: 0,
    step: 0.1,
  },
  {
    name: "Wall Jump Power",
    varN: "wallJP",
    def: 1,
    max: 2,
    min: 0,
    step: 1,
  },
  {
    name: "Strafe Speed",
    varN: "strafeSpd",
    dontChange: true,
    def: 1.2,
    max: 2,
    min: 1,
    step: 0.1,
  },
  {
    name: "Sliding",
    varN: "canSlide",
    def: true,
    bool: true,
  },
  {
    name: "Air Strafe",
    varN: "airStrf",
    dontChange: true,
    def: false,
    bool: true,
  },
  {
    name: "Auto Jump",
    varN: "autoJump",
    def: false,
    bool: true,
  },
  {
    name: "Bullet Drop",
    varN: "bDrop",
    def: false,
    bool: true,
  },
  {
    name: "Health Multiplier",
    head: "Game Logic",
    varN: "healthMlt",
    dontChange: true,
    def: 1,
    max: 3,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Fire Rate",
    varN: "fiRat",
    dontChange: true,
    def: 1,
    max: 2,
    min: 0.5,
    step: 0.1,
  },
  {
    name: "Reload Speed",
    varN: "reSpd",
    dontChange: true,
    def: 1,
    max: 2,
    min: 0.5,
    step: 0.1,
  },
  {
    name: "Health Regen",
    varN: "hpRegen",
    def: true,
    bool: true,
  },
  {
    name: "Kill Rewards",
    varN: "killRewards",
    dontChange: true,
    def: true,
    bool: true,
  },
  {
    name: "Headshots Only",
    varN: "headshotOnly",
    dontChange: true,
    def: false,
    bool: true,
  },
  {
    name: "No Secondaries",
    varN: "noSecondary",
    dontChange: true,
    def: false,
    bool: true,
  },
  {
    name: "Disable Streaks",
    varN: "noStreaks",
    dontChange: true,
    def: false,
    bool: true,
  },
  {
    name: "Disable Borders",
    varN: "disableB",
    def: false,
    bool: true,
  },
  {
    name: "Throwable Melees",
    varN: "throwMel",
    def: true,
    bool: true,
  },
  {
    name: "Select Team",
    head: "Teams",
    varN: "selTeam",
    def: false,
    bool: true,
  },
  {
    name: "Team 1 Name",
    varN: "nameTeam1",
    def: "Team 1",
    hideE: true,
    input: true,
  },
  {
    name: "Team 2 Name",
    varN: "nameTeam2",
    def: "Team 2",
    hideE: true,
    input: true,
  },
  {
    name: "Team 1 Damage",
    varN: "t1Dmg",
    def: 1,
    max: 2,
    min: 0,
    step: 0.1,
  },
  {
    name: "Team 2 Damage",
    varN: "t2Dmg",
    def: 1,
    max: 2,
    min: 0,
    step: 0.1,
  },
  {
    name: "Spectating",
    head: "Other",
    varN: "allowSpect",
    def: true,
    bool: true,
  },
  {
    name: "3rd Person",
    varN: "thirdPerson",
    def: false,
    bool: true,
  },
  {
    name: "Require Captcha",
    varN: "requireCaptcha",
    def: false,
    bool: true,
  },
  {
    name: "Hide Nametags",
    varN: "nameTags",
    def: false,
    bool: true,
  },
];
module.exports.objectLimit = 5000;
module.exports.objectLimitF = 7500;
module.exports.objectColLimit = 3500;
module.exports.objectColLimitF = 6000;
module.exports.spawnLimit = 20;
module.exports.signFontMax = 120;
module.exports.billboardCnt = 6;
module.exports.aiLimit = 20;
module.exports.signLimit = 20;
module.exports.signTextLimit = 1500;
module.exports.signFontMin = 10;
module.exports.triggerLimit = 20;
module.exports.interfaceLimit = 20;
module.exports.interfaceIDMax = 1000;
module.exports.gameConfig = [
  {
    name: "Type",
    varN: "camType",
    cat: 0,
    def: 0,
    options: ["Normal", "Top Down", "Platformer (X)", "Platformer (Z)"],
    select: true,
  },
  {
    name: "X Offset",
    varN: "camOffX",
    cat: 0,
    def: 0,
    max: 500,
    min: 0,
    step: 1,
  },
  {
    name: "Y Offset",
    varN: "camOffY",
    cat: 0,
    def: 0,
    max: 500,
    min: 0,
    step: 1,
  },
  {
    name: "Z Offset",
    varN: "camOffZ",
    cat: 0,
    def: 0,
    max: 500,
    min: 0,
    step: 1,
  },
  {
    name: "Enable Rotation",
    varN: "camRot",
    cat: 0,
    def: true,
    bool: true,
  },
  {
    name: "Model",
    varN: "mdl",
    cat: 1,
    def: 0,
    options: ["Normal", "Sprite", "Custom Asset"],
    select: true,
  },
  {
    name: "Custom Asset",
    varN: "aID",
    cat: 1,
    def: "",
    input: true,
  },
  {
    name: "Custom Asset Scale",
    varN: "mdlS",
    cat: 1,
    def: 1,
    max: 100,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Speed X",
    varN: "speedX",
    cat: 1,
    def: 1,
    max: 3,
    min: 0,
    step: 0.1,
  },
  {
    name: "Speed Y",
    varN: "speedY",
    cat: 1,
    def: 1,
    max: 3,
    min: 0,
    step: 0.1,
  },
  {
    name: "Speed Z",
    varN: "speedZ",
    cat: 1,
    def: 1,
    max: 3,
    min: 0,
    step: 0.1,
  },
  {
    name: "Ladder Accel",
    varN: "ldA",
    cat: 1,
    def: 1,
    max: 5,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Air Accel",
    varN: "arA",
    cat: 1,
    def: 1,
    max: 3,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Slide Time",
    varN: "slT",
    cat: 1,
    def: 1,
    max: 3,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Slide Accel",
    varN: "slA",
    cat: 1,
    def: 1,
    max: 1.5,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Jump Cooldown",
    varN: "jpC",
    cat: 1,
    def: 1,
    max: 3,
    min: 0.1,
    step: 0.1,
  },
  {
    name: "Infinite Jump",
    varN: "infJ",
    cat: 1,
    def: false,
    bool: true,
  },
];
module.exports.fetMapsH = [{}];
module.exports.weaponConfig = [
  {
    name: "Damage",
    varN: "dmg",
    max: 200,
    min: 1,
    step: 1,
    decs: 0,
  },
  {
    name: "Headshot Mlt",
    varN: "hsMlt",
    max: 3,
    min: 0.5,
    step: 0.0001,
    decs: 4,
  },
  {
    name: "Ammo",
    varN: "ammo",
    max: 100,
    min: 1,
    step: 1,
    decs: 0,
  },
  {
    name: "Rate",
    varN: "rate",
    max: 1000,
    min: 70,
    step: 10,
    decs: 0,
  },
  {
    name: "Reload Time",
    varN: "reload",
    max: 5000,
    min: 500,
    step: 25,
    decs: 0,
  },
  {
    name: "Swap Time",
    varN: "swapTime",
    max: 1000,
    min: 100,
    step: 10,
    decs: 0,
  },
  {
    name: "Aim Speed",
    varN: "aimSpd",
    max: 500,
    min: 100,
    step: 10,
    decs: 0,
  },
  {
    name: "Move Speed",
    varN: "spdMlt",
    max: 3,
    min: 0.5,
    step: 0.01,
    decs: 2,
  },
  {
    name: "Pierce",
    varN: "pierce",
    max: 1,
    min: 0,
    step: 0.05,
    decs: 2,
  },
  {
    name: "Range",
    varN: "range",
    max: 2000,
    min: 5,
    step: 1,
    decs: 0,
  },
  {
    name: "Damage Drop",
    varN: "dmgDrop",
    max: 100,
    min: 0,
    step: 1,
    decs: 0,
  },
  {
    name: "Spread",
    varN: "spread",
    max: 500,
    min: 10,
    step: 10,
    decs: 0,
  },
  {
    name: "Min Spread",
    varN: "minSpread",
    max: 100,
    min: 5,
    step: 1,
    decs: 0,
  },
  {
    name: "Zoom",
    varN: "zoom",
    max: 3,
    min: 1,
    step: 0.01,
    decs: 2,
  },
  {
    name: "Recoil",
    varN: "recoil",
    max: 0.05,
    min: 0,
    step: 0.0001,
    decs: 4,
  },
  {
    name: "Recoil Y",
    varN: "recoilYM",
    max: 1,
    min: 0,
    step: 0.01,
    decs: 2,
  },
  {
    name: "Recoil Z",
    varN: "recoilZ",
    max: 10,
    min: 0,
    step: 0.1,
    decs: 2,
  },
  {
    name: "Recoil Z Aim",
    varN: "recoilZM",
    max: 1,
    min: -1,
    step: 0.01,
    decs: 2,
  },
  {
    name: "Jump Power",
    varN: "jumpYM",
    max: 1,
    min: 0.1,
    step: 0.01,
    decs: 2,
  },
  {
    name: "Impulse Range",
    varN: "physRang",
    max: 100,
    min: 0,
    step: 1,
    decs: 0,
  },
  {
    name: "Impulse Power",
    varN: "physPow",
    max: 2,
    min: 0,
    step: 0.001,
    decs: 3,
  },
  {
    name: "Secondary",
    varN: "secondary",
    bool: true,
  },
  {
    name: "Akimbo",
    varN: "akimbo",
    bool: true,
  },
  {
    name: "Single Fire",
    varN: "nAuto",
    bool: true,
  },
  {
    name: "No Spread",
    varN: "noSpread",
    bool: true,
  },
  {
    name: "Disable ADS",
    varN: "noAim",
    bool: true,
  },
];
module.exports.followInd = 40;
module.exports.followURLS = [
  "https://www.youtube.com/channel/UCivv7CI0mzjeBiz8E-z5YPw",
];
module.exports.recVids = [
  "https://www.youtube.com/embed/KU4UOD802pM",
  "https://www.youtube.com/embed/_2YzOlRJ1lU",
  "https://www.youtube.com/embed/eyotedXeW8Y",
  "https://www.youtube.com/embed/kuTCye_s_D4",
  "https://www.youtube.com/embed/tkqPBqm4JRw",
];
module.exports.whoToFol = [
  {
    name: "Sidney",
    tag: "Developer",
    id: 201211,
  },
  {
    name: "Vince",
    tag: "Developer",
    id: 105683,
  },
  {
    name: "Tehchy",
    tag: "Developer",
    id: 289362,
  },
  {
    name: "MoonJuiceAlt",
    alias: "MoonJuice",
    tag: "Streamer",
    id: 2968503,
  },
  {
    name: "ImWaspy",
    tag: "Streamer",
    id: 2593871,
  },
  {
    name: "hey_im_zed",
    alias: "HeyImZed",
    tag: "Streamer",
    id: 177694,
  },
  {
    name: "cimota",
    tag: "Skin Maker",
    id: 7516049,
  },
  {
    name: "Kilfy",
    tag: "Skin Maker",
    id: 8871318,
  },
  {
    name: "iSpy",
    tag: "Skin Maker",
    id: 177694,
  },
  {
    name: "Nxbulah",
    tag: "Skin Maker",
    id: 5739887,
  },
  {
    name: "Skriller33",
    tag: "Skin Maker",
    id: 5068654,
  },
  {
    name: "Andrii",
    tag: "Map Maker",
    id: 163429,
  },
  {
    name: "JavieBhop",
    tag: "Map Maker",
    id: 1517556,
  },
  {
    name: "Andrii",
    tag: "Map Maker",
    id: 163429,
  },
  {
    name: "Keybi",
    tag: "Map Maker",
    id: 310968,
  },
  {
    name: "thejavi99",
    tag: "Map Maker",
    id: 1498591,
  },
  {
    name: "owOmar",
    tag: "Mod Maker",
    id: 5461278,
  },
  {
    name: "siktis",
    tag: "Mod Maker",
    id: 5746131,
  },
  {
    name: "DukeV",
    tag: "Map Maker",
    id: 943615,
  },
  {
    name: "Chwoubaka",
    tag: "Mod Maker",
    id: 4927907,
  },
  {
    name: "PhilZ",
    tag: "Youtuber",
    id: 2378875,
  },
  {
    name: "FrostyWolfTTV",
    alias: "FrostyWolf",
    tag: "Streamer",
    id: 5090891,
  },
  {
    name: "JamemesG",
    tag: "E-Sports",
    id: 3524000,
  },
  {
    name: "jcStani",
    tag: "E-Sports",
    id: 6895308,
  },
  {
    name: "COLOR",
    tag: "E-Sports",
    id: 164485,
  },
  {
    name: "roadman",
    tag: "E-Sports",
    id: 241773,
  },
  {
    name: "revzi",
    tag: "E-Sports",
    id: 8345163,
  },
  {
    name: "Mosswi",
    tag: "Staff",
    id: 2768744,
  },
  {
    name: "wingmangod69",
    alias: "Wingman",
    tag: "E-Sports",
    id: 2449631,
  },
  {
    name: "Swixie",
    tag: "Streamer",
    id: 5720620,
  },
  {
    name: "QuackyTTV",
    alias: "Quacky",
    tag: "Streamer",
    id: 3742667,
  },
  {
    name: "Highnoon",
    tag: "Support",
    id: 361086,
  },
  {
    name: "StremZ",
    tag: "Streamer",
    id: 5045705,
  },
];
module.exports.minBid = 100;
module.exports.billbHours = 2;
module.exports.billbTime = module.exports.billbHours * 3600000;
module.exports.billbUpdtI = 600000;
module.exports.impresstimate = 200000;
module.exports.bidMinLvl = 20;
module.exports.bidEnabled = true;
module.exports.gravity = 0.00015;
module.exports.deathY = -100;
module.exports.skyScale = 18000;
module.exports.shadowDst = 1200;
module.exports.shadowRes = 1024;
module.exports.shadowOff = 0.004;
module.exports.lightDistance = 500;
module.exports.lightIntensity = 1.3;
module.exports.ambIntensity = 1;
module.exports.cornerScl = 2.5;
module.exports.cornerH = 7;
module.exports.wallH = 5;
module.exports.wallW = 0.8;
module.exports.sunAngleX = 90;
module.exports.sunAngleY = 54;
module.exports.cornerPad = 1;
module.exports.diskSpin = 0.0002;
module.exports.ladderWidth = 3.2;
module.exports.ladderScale = 0.5;
module.exports.terrainGrid = 8;
module.exports.maxTerrainS = 4000;
module.exports.otherSoundMlt = 0.55;
module.exports.networkSounds = [
  "spray",
  "taunt_0",
  "taunt_1",
  "taunt_2",
  "taunt_3",
  "weapon_1",
  "weapon_1_0",
  "weapon_2",
  "weapon_3",
  "weapon_4",
  "weapon_5",
  "weapon_6",
  "weapon_7",
  "weapon_8",
  "weapon_9",
  "weapon_10",
  "weapon_11",
  "weapon_12",
  "weapon_13",
  "weapon_14",
  "weapon_15",
  "weapon_16",
  "weapon_17",
  "weapon_18",
  "weapon_6_0",
  "weapon_1_2",
  "weapon_3_0",
  "weapon_3_2",
  "taunt_4",
  "weapon_2_0",
  "weapon_1_4",
  "weapon_1_3",
  "weapon_17",
  "weapon_8_0",
  "weapon_10_0",
  "collect_1",
  "melee_12",
  "headshot_0",
  "weapon_4_0",
  "melee_14",
  "beep_0",
  "bo_plant",
  "bo_diff",
  "weapon_1_5",
  "weapon_19",
  "melee_19",
  "jump_0",
  "jump_1",
  "step_0",
  "step_1",
  "step_2",
];
module.exports.particleIDS = ["default", "grass", "fog", "ember"];
module.exports.maxParticles = 100;
module.exports.explosionRange = 200;
module.exports.particleDist = 40;
module.exports.particleBlending = [
  "None",
  "Normal",
  "Additive",
  "Subtractive",
  "Multiply",
];
module.exports.projSpreads = [
  0.1, -0.8, 0.3, 1, 0.1, -0.4, -0.1, 0.3, 0.5, -0.45, 0.2, -0.2,
];
module.exports.minDrop = 300;
module.exports.dropR = 0.1;
module.exports.chatMaxLength = 70;
module.exports.chatInterval = 800;
module.exports.voiceChatInterval = 2000;
module.exports.chatListLength = 35;
module.exports.voiceChatMaxLength = 0.65;
module.exports.voiceRate = 500;
module.exports.voiceDelay = 200;
module.exports.invisChar = "&lrm;";
module.exports.gbr = false;
module.exports.mouseSens = 0.0024;
module.exports.camChaseTrn = 0.0022;
module.exports.camChaseSpd = 0.0012;
module.exports.camChaseSen = 0.2;
module.exports.camChaseDst = 24;
module.exports.specMinD = 10;
module.exports.specMaxD = 160;
module.exports.menuCamDist = 200;
module.exports.menuCamAngle = -0.5;
module.exports.menuCamSpeed = 0.1;
module.exports.idleAnimS = 0.0015;
module.exports.animMult = 1.2;
module.exports.leanPull = 0.99;
module.exports.leanSens = 0.05;
module.exports.leanMax = 0.16;
module.exports.leanPullZ = 0.99;
module.exports.leanMltZ = 0.03;
module.exports.bobMltY = 0.024;
module.exports.bobPullY = 0.985;
module.exports.bobPullZ = 0.99;
module.exports.landPull = 0.994;
module.exports.landPullV = 0.985;
module.exports.bobMltZ = 0.02;
module.exports.landOff = 0.15;
module.exports.aimAnimMlt = 0.18;
module.exports.aimSlow = 0.55;
module.exports.aimJumpSlow = 0.85;
module.exports.stepAnim = 0.075;
module.exports.stepMlt = 0.25;
module.exports.stepPull = 0.995;
module.exports.collPad = 1.1;
module.exports.hpSegments = 7;
module.exports.maxHealth = 100;
module.exports.passiveInc = 500;
module.exports.cameraHeight = 1.5;
module.exports.playerSpeed = 0.00042;
module.exports.slippingSpeed = 0.0003;
module.exports.ladderSpeed = 0.035;
module.exports.ladderDecel = 0.97;
module.exports.slideDecel = 0.999;
module.exports.slideTime = 350;
module.exports.terrainSlideDecel = 0.9996;
module.exports.groundDecel = 0.99;
module.exports.terrainDecel = 0.99;
module.exports.terrainSlipDecel = 0.99;
module.exports.airSpeed = 0.000047;
module.exports.airDecel = 0.9996;
module.exports.jumpVel = 0.072;
module.exports.jumpPush = 0.1;
module.exports.decelMin = 0.0001;
module.exports.climbHeight = 3;
module.exports.cornerGlide = 4;
module.exports.wpnSpin = 0.018;
module.exports.terrainSlideThreshold = 1.9;
module.exports.terrainGravityMlt = 1.85;
module.exports.playerSlideVelMlt = 1.2;
module.exports.playerTerrainSlideVelMlt = 0.4;
module.exports.playerSlippingJumpCooldown = 500;
module.exports.materialDens = {
  flesh: 0.2,
  default: 0.5,
};
module.exports.nameOffset = 0.6;
module.exports.nameOffsetHat = 0.8;
module.exports.maxNameLength = 14;
module.exports.maxPassLength = 20;
module.exports.minPassLength = 6;
module.exports.playerHeight = 11;
module.exports.chestWidth = 2.6;
module.exports.chestScale = 1.3;
module.exports.armScale = 1.2;
module.exports.legScale = 1.3;
module.exports.uArmLength = 2.7;
module.exports.armInset = -0.1;
module.exports.lArmLength = 2.7;
module.exports.headScale = 2;
module.exports.armOff = -0.8;
module.exports.legHeight = 4.2;
module.exports.playerScale =
  (module.exports.armScale * 2 +
    module.exports.chestWidth +
    module.exports.armInset) /
  2;
module.exports.hitBoxPad = 1;
module.exports.tracerMinDst = 20;
module.exports.tracerMaxDst = 500;
module.exports.tracerChance = 1;
module.exports.crouchLean = Math.PI * -0.1;
module.exports.crouchDst = 3;
module.exports.crouchSlow = 0.3;
module.exports.crouchSpd = 0.007;
module.exports.crouchJump = 0.25;
module.exports.crouchSpread = 0.55;
module.exports.crouchAnim = 0.0008;
module.exports.crouchAnimMlt = 0.5;
module.exports.spreadMove = 25;
module.exports.spreadFall = 30;
module.exports.spreadRecover = 0.985;
module.exports.spreadAdj = 0.00063;
module.exports.spreadMlt = 240;
module.exports.recoilMlt = 0.3;
module.exports.flagMsg = "You have the Flag";
module.exports.flagMsgE = "Enemy has your Flag";
module.exports.flagMsgRC = "Enemy has your Flag";
module.exports.flagZoneS = 24;
module.exports.flagZoneH = 36;
module.exports.flagScale = 12;
module.exports.flagOff = 6;
module.exports.flagHOff = 15;
module.exports.flagUpdate = 2500;
module.exports.interactTimer = 100;
module.exports.pickupZoneX = 12;
module.exports.pickupZoneZ = 4;
module.exports.pickupZoneH = 2;
module.exports.pickupScale = 6;
module.exports.pickupOff = 1;
module.exports.maxLevel = 102;
module.exports.maxELOLevel = 8;
module.exports.assistTime = 5000;
module.exports.assistScore = 25;
module.exports.assistMin = 20;
module.exports.scoreStreak = 2000;
module.exports.medalAnim = 1000;
module.exports.medalDelay = 900;
module.exports.feedTimer = 2000;
module.exports.spinTimer = 1800;
module.exports.endStats = ["sid", "name", "score", "kills", "deaths", "reward"];
module.exports.endForm = {
  reward: function (h) {
    if (h) {
      return "<span style='color:#F8C55C'>+" + h + "</span> KR";
    } else {
      return "NONE";
    }
  },
  MMR: function (h, j, k) {
    var l = (k.account && k.account[j.queueConfig.accountKey]) || 0;
    return (
      "<span style='color:#F8C55C'><span style='color:rgba(255, 255, 255, 0.7);'>" +
      ((l = k.ELO >= 0 ? l - k.ELO : l + Math.abs(k.ELO)) < 0 ? 0 : l).round(
        1,
      ) +
      "</span> " +
      (k.ELO >= 0 ? "+" : "-") +
      Math.abs(k.ELO.round(1)) +
      "</span>"
    );
  },
  time: function (h, j, k) {
    return k.timer || "DNF";
  },
  infected: function (h, j, k) {
    return k.convs;
  },
  found: function (h, j, k) {
    return k.convs;
  },
  weapon: function (h, j, k) {
    return k.weaponTier;
  },
  objective: function (h, j, k) {
    return k.objectiveScore || 0;
  },
  confirms: function (h, j, k) {
    return k.confirms || 0;
  },
  denies: function (h, j, k) {
    return k.denies || 0;
  },
  dmg: function (h, j, k) {
    return Math.round(k.dmgDealt || 0);
  },
};
module.exports.hitLife = 2000;
module.exports.regenDelay = 5000;
module.exports.regenVal = 0.1;
module.exports.sprayRange = 25;
module.exports.sprayTimer = 1000;
module.exports.sprayScale = 15;
module.exports.deathDelay = 2800;
module.exports.deathFollowD = 100;
module.exports.suicides = [
  "uninstall life",
  "toaster bath",
  "alt f4",
  "not alive",
  "neck rope",
  "scooter ankle",
  "death.exe",
];
module.exports.taunts = [
  {
    nm: "taunt_0",
    id: 1,
    tm: 500,
  },
  {
    nm: "taunt_1",
    id: 2,
    tm: 1000,
  },
  {
    nm: "taunt_2",
    id: 3,
    tm: 2300,
  },
  {
    nm: "taunt_3",
    id: 4,
    tm: 3200,
  },
  {
    nm: "taunt_4",
    id: 28,
    tm: 3200,
  },
];
module.exports.fov = 80;
module.exports.viewDist = 2000;
module.exports.nameVisRate = 200;
module.exports.worldUV = 60;
module.exports.ambientVal = 0.5;
module.exports.ambD = 2;
module.exports.ambMlt = 15;
module.exports.ambOff = 0.09;
module.exports.ambScale = 8;
module.exports.ambDiv = 20;
module.exports.ambSFactor = 1;
module.exports.ambBleed = 0;
module.exports.boosterSpd = 0.002;
module.exports.boostRange = 100;
module.exports.minMountainMlt = 0;
module.exports.maxZoneSize = 10000;
module.exports.maxTerrainSize = 8000;
module.exports.minTerrainSize = 0;
module.exports.maxMountainMlt = 5;
module.exports.minZoneSize = 0;
module.exports.maxShrinkSpeed = 10;
module.exports.minShrinkSpeed = 1;
module.exports.positionRange = 500000;
module.exports.quadSize = 50;
module.exports.emitterVolMin = 0.05;
module.exports.emitterVolMax = 2;
module.exports.emitterRateMin = 0.5;
module.exports.emitterRollMin = 0;
module.exports.emitterRollMax = 1;
module.exports.emitterRateMax = 4;
module.exports.emitterDistMin = 0;
module.exports.emitterDistMax = 5000;
module.exports.emitterSounds = [
  "nuke_0",
  "siren_0",
  "explosion",
  "fart_0",
  "taunt_0",
  "taunt_1",
  "taunt_2",
  "taunt_3",
  "buy_0",
  "buy_1",
  "case_0",
  "case_1",
  "cheer_0",
  "reward",
  "store",
  "tick_0",
  "jumpS_0",
  "cough_1",
  "cough_2",
  "taunt_4",
  "ambient_1",
  "ambient_2",
  "ambient_3",
  "ambient_4",
  "ambient_5",
  "ambient_6",
  "ambient_7",
  "ambient_8",
  "beep_0",
  "bo_plant",
  "bo_diff",
  "collect_1",
  "bounce_0",
  "headshot_0",
  "hit_0",
  "impact_0",
  "jump_0",
  "jump_1",
  "land_0",
  "punch_0",
  "punch_1",
  "slide_0",
  "spray",
  "step_0",
  "step_1",
  "step_2",
  "whizz_0",
  "whizz_1",
  "gclick_0",
  "pick_0",
  "pick_1",
];
module.exports.maxThumb = 80;
module.exports.maxThumbP = 150;
module.exports.maxPfp = 80;
module.exports.aiSyncT = 5;
module.exports.aiBehavs = ["Idle", "Chase"];
module.exports.assetLvl = 20;
module.exports.assetCost = 0.05;
module.exports.assetCostP = 0;
module.exports.assetUploads = 100;
module.exports.assetUploadsF = 200;
module.exports.assetUploadsP = 300;
module.exports.assetSize = 50;
module.exports.assetSizeP = 250;
module.exports.assetThumb = 100;
module.exports.assetData = 55;
module.exports.assetTexture = 75;
module.exports.assetSound = 75;
module.exports.assetCat = [
  "Clutter",
  "Decoration",
  "Trees & Vegetation",
  "Vehicles",
  "Buildings",
  "Furniture",
  "Stones & Rubble",
  "Technology",
  "Weapons",
  "Random & Strange",
  "Tools",
  "Food & Drink",
  "Characters & Creatures",
  "Fashion & Clothes",
  "Game Map",
  "Walls & Blocks",
  "Textures",
  "Sounds",
];
module.exports.mapCats = [
  "Other",
  "Zombies",
  "Parkour",
  "Trading",
  "Social",
  "Horror",
  "Puzzle",
  "Training",
  "Battle Royale",
  "Realism",
  "Rotation",
  "Raid",
];
module.exports.mapInfos = {
  burg: {
    year: "2018",
    version: "3.2",
  },
  littletown: {
    year: "2018",
    version: "0.9",
  },
  sandstorm: {
    year: "2019",
    creator: "CrispyCrust",
    version: "2.3",
  },
  subzero: {
    year: "2019",
    creator: "CrispyCrust",
    version: "0.9",
  },
  undergrowth: {
    year: "2019",
    creator: "CrispyCrust",
    version: "1.2",
  },
  shipyard: {
    year: "2019",
    creator: "Chwoubaka",
    version: "1.0",
  },
  freight: {
    year: "2019",
    version: "2.1",
  },
  lostworld: {
    year: "2020",
    creator: "DasIstWalter",
    version: "1.2",
  },
  citadel: {
    year: "2020",
    version: "2.4",
  },
  oasis: {
    year: "2020",
    creator: "DasIstWalter",
    version: "0.2",
  },
  kanji: {
    year: "2020",
    creator: "Arbiter",
    version: "5.2",
  },
  newtown: {
    year: "2020",
    creator: "Arbiter",
    version: "0.1",
  },
  industry: {
    year: "2020",
    creator: "CrispyCrust",
    version: "1.0",
  },
  evacuation: {
    year: "2020",
    creator: "Creationfier",
    version: "Test",
  },
};
module.exports.borderH = 250;
module.exports.soundScapes = {
  Default: 1,
  City: 2,
  Desert: 3,
  Market: 4,
  Scary: 5,
  Storm: 6,
  Purgatory: 7,
  "Black Market": 8,
  Tomb: 11,
};
module.exports.amvVols = {
  6: 0.3,
  7: 0.4,
};
module.exports.mapTabs = [
  {
    n: "Popular",
    cache: true,
    c: 42,
    t: "recent",
  },
  {
    n: "Featured",
    noPages: true,
    cache: true,
    c: 42,
    t: "featured",
  },
  {
    n: "New",
    cache: true,
    c: 42,
    t: "initialdate",
  },
  {
    n: "Favorites",
    c: 42,
    sendID: true,
    fav: true,
  },
  {
    n: "My Games",
    c: 42,
    sendID: true,
    t: "votes",
  },
  {
    n: "Search",
    search: true,
    t: "votes",
  },
];
module.exports.modSize = 25;
module.exports.modSizeP = 50;
module.exports.modTabs = [
  {
    n: "Popular",
    cache: true,
    c: 42,
    t: "recent",
  },
  {
    n: "Featured",
    noPages: true,
    cache: true,
    c: 42,
    t: "featured",
  },
  {
    n: "New",
    cache: true,
    c: 42,
    t: "initialdate",
  },
  {
    n: "Favorites",
    c: 42,
    sendID: true,
    fav: true,
  },
  {
    n: "My Mods",
    c: 42,
    sendID: true,
    t: "votes",
  },
  {
    n: "Search",
    search: true,
    t: "votes",
  },
];
module.exports.mailTabs = [
  {
    n: "Unread",
  },
  {
    n: "Archive",
  },
];
module.exports.assetTabs = [
  {
    n: "New",
  },
  {
    n: "My Assets",
    sendUser: true,
  },
  {
    n: "Search",
    search: true,
  },
];
module.exports.giftMax = 10000000;
module.exports.giftMin = 10;
module.exports.giftMinLVl = 30;
module.exports.saleMax = 10000000;
module.exports.saleGrace = 300000;
module.exports.marketMinLVl = 20;
module.exports.marketFeeBypass = 0;
module.exports.priceUpdate = 43200000;
module.exports.streamRotation = 10000;
module.exports.creatorReset = 604800000;
module.exports.dropsEnabled = false;
module.exports.redeemDrops = false;
module.exports.dropsClientId = "b7kkb27v7p3q6eh4u0ijx1dp26s8m3";
module.exports.clanRegions = [
  {
    name: "North America",
    pos: [140, 180],
    endSize: 1000,
    endPos: [-20, -70],
  },
  {
    name: "South America",
    pos: [230, 285],
    endSize: 950,
    endPos: [-130, -210],
  },
  {
    name: "Western Europe",
    pos: [380, 170],
    endSize: 1300,
    endPos: [-510, -120],
  },
  {
    name: "Africa",
    pos: [380, 250],
    endSize: 900,
    endPos: [-300, -130],
  },
  {
    name: "Middle East",
    pos: [430, 210],
    endSize: 1700,
    endPos: [-830, -280],
  },
  {
    name: "Asia",
    pos: [530, 210],
    endSize: 1100,
    endPos: [-640, -140],
  },
  {
    name: "Oceania",
    pos: [600, 310],
    endSize: 1500,
    endPos: [-1060, -430],
  },
  {
    name: "Eastern Europe",
    pos: [476, 165],
    endSize: 900,
    endPos: [-460, -30],
  },
];
module.exports.clanTabs = ["Members", "Stats", "Requests", "Clan War"];
module.exports.maxClanContr = 30;
module.exports.maxContrsT = 50;
module.exports.clanWarLives = 250;
module.exports.clanRoles = [
  {
    name: "Recruit",
  },
  {
    name: "Soldier",
    earn: true,
    max: 25,
  },
  {
    name: "Captain",
    earn: true,
    max: 5,
    perms: 1,
  },
  {
    name: "Commander",
    earn: true,
    max: 1,
    perms: 2,
  },
];
module.exports.accAnnounceId = 0;
module.exports.accAnnounce = [
  "Make sure to use a secure password.",
  "Update your password frequently and keep it in a secure place.",
  "Instead of using a password like pass123,",
  "please use something more secure like x&fyUyp92fH2sXf",
];
module.exports.newDataInterval = 120000;
module.exports.profileTabs = ["Stats", "Partner", "Settings", "Twitch"];
module.exports.socials = [
  "leaders",
  "profile",
  "maps",
  "market",
  "itemsales",
  "clan",
  "map",
  "virus",
  "search",
  "blackm",
  "mods",
  "clanwars",
  "mod",
  "feed",
];
module.exports.marketQueries = {
  market: {
    btn: "Info",
    checkItem: function (h) {
      return !!h.funds;
    },
  },
  inventory: {
    btn: "List to Sell",
    checkItem: function (h) {
      return !h.funds && h.c;
    },
  },
  sales: {
    btn: "Unlist",
    checkItem: function (h) {
      return !!h.funds;
    },
  },
  stats: {},
  trades: {},
};
module.exports.leaderQueries = [
  "player_score",
  "player_elo",
  "player_elo2",
  "player_elo4",
  "player_kills",
  "player_wins",
  "player_timeplayed",
  "player_funds",
  "player_clan",
  "player_chal",
  "player_followed",
];
module.exports.leaderCal = {
  player_score: function (h) {
    var j = Math.max(1, Math.floor(module.exports.rankVar * Math.sqrt(h)));
    return (
      "<span class='floatR'><img src='./img/levels/" +
      Math.max(
        Math.min(module.exports.maxLevel - 1, j.roundToNearest(2) - 1),
        0,
      ) +
      ".png' class='rnkIcon'>" +
      j +
      "</span>"
    );
  },
  player_elo: function (h) {
    return (
      "<span class='floatR'><img src='./img/ranks/icon_" +
      (Math.max(
        Math.min(
          module.exports.maxELOLevel,
          Math.floor((h || 0) / module.exports.eloPer),
        ),
        1,
      ) -
        1) +
      ".png' class='rnkIconR'></span>"
    );
  },
  player_elo2: function (h) {
    return (
      "<span class='floatR'><img src='./img/ranks/icon_" +
      (Math.max(
        Math.min(
          module.exports.maxELOLevel,
          Math.floor((h || 0) / module.exports.eloPer),
        ),
        1,
      ) -
        1) +
      ".png' class='rnkIconR'></span>"
    );
  },
  player_elo4: function (h) {
    return (
      "<span class='floatR'><img src='./img/ranks/icon_" +
      (Math.max(
        Math.min(
          module.exports.maxELOLevel,
          Math.floor((h || 0) / module.exports.eloPer),
        ),
        1,
      ) -
        1) +
      ".png' class='rnkIconR'></span>"
    );
  },
  player_kills: function (h) {
    return h + "<span class='lName'> kills</span>";
  },
  player_wins: function (h) {
    return h + "<span class='lName'> wins</span>";
  },
  player_funds: function (h) {
    return (
      "<span style='color:rgba(0,0,0,0.4)'>" +
      h.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      "</span> KR"
    );
  },
  player_timeplayed: function (h) {
    var j = h / 1000 / 60;
    var k = parseInt(j % 60);
    j /= 60;
    var l = parseInt(j % 24);
    j /= 24;
    var m = parseInt(j);
    return (m ? m + "d " : "") + (l ? l + "h " : "") + (k || 0) + "m ";
  },
  player_chal: function (h) {
    return Math.min(module.exports.maxChal, h + 1);
  },
  player_followed: function (h) {
    return (
      (h || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      " <span class='lName'>followers</span>"
    );
  },
  player_eventcount: function (h) {
    return (
      "<span class='lName'>found</span> " + h + "/" + module.exports.easterEggs
    );
  },
};
module.exports.socialRegions = [
  "All Regions",
  "Oceania",
  "Asia",
  "Europe",
  "Americas",
];
module.exports.regionNames = {
  local: "Local",
  "us-nj": "New York",
  "us-il": "Chicago",
  "us-tx": "Dallas",
  "us-wa": "Seattle",
  "us-ca-la": "Los Angeles",
  "us-ga": "Atlanta",
  "nl-ams": "Amsterdam",
  "gb-lon": "London",
  "de-fra": "Frankfurt",
  "us-ca-sv": "Silicon Valley",
  "au-syd": "Sydney",
  "fr-par": "Paris",
  "jb-hnd": "Tokyo",
  "us-fl": "Miami",
  sgp: "Singapore",
  blr: "India",
  brz: "Brazil",
  "me-bhn": "Middle East",
  "af-ct": "South Africa",
};
module.exports.langNames = {
  en: "English",
  es: "Spanish",
  de: "German",
  kr: "Korean",
  pr: "Portuguese",
};
module.exports.skinColors = [
  {
    id: 0,
    col: 8412234,
    name: "Bronze",
  },
  {
    id: 1,
    col: 10975328,
    name: "Sienna",
  },
  {
    id: 2,
    col: 13864303,
    name: "Rose",
  },
  {
    id: 3,
    col: 13408638,
    name: "Tan",
  },
  {
    id: 4,
    col: 15581094,
    name: "Pale",
  },
  {
    id: 5,
    col: 8492161,
    name: "Infected",
    req: function (h) {
      return h && h.virus;
    },
  },
];
module.exports.reportOptions = [
  "Hacking",
  "Exploiting",
  "Scamming",
  "Harassment",
  "Other",
  "Boosting",
  "Market Scripting",
];
module.exports.serverMessages = [
  "$ joined the game",
  "$ left the game",
  "$ was kicked",
  "$ was banned",
  "$ was vote kicked",
  "$ was arrested by the K.P.D",
];
module.exports.customRatios = [
  "Native",
  "800x600",
  "1024x768",
  "1280x960",
  "1280x1024",
  "1440x1080",
  "1656x1080",
];
module.exports.unObtainCols = [
  "Crimson",
  "orange",
  "yellow",
  "lime",
  "MediumBlue",
];
module.exports.killCardStats = [
  {
    name: "SPK",
    stat: function (h) {
      return (
        (h.account.score || 0) / Math.max(h.account.kills || 0, 1)
      ).toFixed(2);
    },
  },
  {
    name: "Kills",
    stat: function (h) {
      return h.account.kills || 0;
    },
  },
  {
    name: "Deaths",
    stat: function (h) {
      return h.account.deaths || 0;
    },
  },
  {
    name: "KDR",
    stat: function (h) {
      return (
        (h.account.kills || 0) / Math.max(h.account.deaths || 0, 1)
      ).toFixed(2);
    },
  },
  {
    name: "KPG",
    stat: function (h) {
      return (
        (h.account.kills || 0) / Math.max(h.account.games || 0, 1)
      ).toFixed(2);
    },
  },
  {
    name: "Games Played",
    stat: function (h) {
      return h.account.games || 0;
    },
  },
  {
    name: "Wins",
    stat: function (h) {
      return h.account.wins || 0;
    },
  },
  {
    name: "W/L",
    stat: function (h) {
      return (
        (h.account.wins || 0) /
        Math.max((h.account.games || 0) - (h.account.wins || 0), 1)
      ).toFixed(2);
    },
  },
  {
    name: "Nukes",
    stat: function (h) {
      return h.account.stats.n || 0;
    },
  },
  {
    name: "Melees",
    stat: function (h) {
      return h.account.stats.mk || 0;
    },
  },
  {
    name: "Accuracy",
    stat: function (h) {
      return (
        (h.account.stats.s
          ? ((h.account.stats.h || 0) / h.account.stats.s) * 100
          : 0
        ).round(1) + "%"
      );
    },
  },
  {
    name: "KR",
    stat: function (h) {
      return h.account.funds || 0;
    },
  },
  {
    name: "Challenge Level",
    stat: function (h) {
      return (h.account.chal || 0) + 1;
    },
  },
  {
    name: "Headshots",
    stat: function (h) {
      return h.account.stats.hs || 0;
    },
  },
  {
    name: "Solo Ranked",
    stat: function (h) {
      return h.account.elo || 0;
    },
  },
  {
    name: "Duo Ranked",
    stat: function (h) {
      return h.account.elo2 || 0;
    },
  },
  {
    name: "Quad Ranked",
    stat: function (h) {
      return h.account.elo4 || 0;
    },
  },
  {
    name: "Losses",
    stat: function (h) {
      return Math.max((h.account.games || 0) - (h.account.wins || 0), 0);
    },
  },
  {
    name: "Wallbangs",
    stat: function (h) {
      return h.account.stats.wb || 0;
    },
  },
  {
    name: "Beatdowns",
    stat: function (h) {
      return h.account.stats.fk || 0;
    },
  },
  {
    name: "Bullseyes",
    stat: function (h) {
      return h.account.stats.tmk || 0;
    },
  },
];
module.exports.mapGenProps = {
  manager: {
    props: {
      aoOpac: {},
      objects: {
        isGameObject: true,
      },
      objectives: {},
      flags: {
        isGameObject: true,
      },
      sites: {},
      pickups: {
        isGameObject: true,
      },
      gates: {
        isGameObject: true,
      },
      banks: {
        isGameObject: true,
      },
      terminals: {
        isGameObject: true,
      },
      interfaces: {},
      destObjs: {},
      timerObjs: {},
      teleporters: {
        isGameObject: true,
      },
      spectateCams: {
        isGameObject: true,
      },
      grids: {
        isGameObject: true,
      },
      pendingAIs: {},
    },
  },
  maps: {},
  spawns: {},
  lastGen: {},
  terrainConfig: {
    isTerrainConfig: true,
  },
  zoneConfig: {
    isZoneConfig: true,
  },
  config: {},
  deathY: {},
  mapHeight: {},
  mapDims: {},
};
module.exports.gameObjectReferenceProps = ["flagObj"];
module.exports.scriptSetts = [
  "sensitivityX",
  "sensitivityY",
  "aimSensitivityX",
  "aimSensitivityY",
  "invertY",
  "fov",
  "fpsFOV",
  "weaponBob",
  "weaponLean",
  "weaponOffX",
  "weaponOffY",
  "weaponOffZ",
  "weaponADSOffY",
  "aimAnim",
  "hideADS",
  "showHands",
  "showWeapon",
  "showWeaponSec",
  "showWeaponMel",
  "particles",
  "particlesDist",
  "renderDist",
  "shadows",
  "shadowsDynamic",
  "ambientShading",
  "scaleUI",
  "oldScoreboard",
  "weaponRot",
];
module.exports.socialEmbeds = [
  "imwaspy",
  "frostywolf",
  "swixiethinks",
  "moonjuice",
  "quacky",
  "heyimzed",
  "themeatman__",
  "teds",
  "vadrastos",
  "rain_song",
  "stremz",
  "miserynae",
  "ryanpu",
  "kashy",
  "hxllxw_",
  "nns__kr",
  "kaarson",
  "syctis",
  "itsabsent",
];
module.exports.blankMap =
  '{"name":"Test","ambient":"#97a0a8","light":"#f2f8fc","sky":"#dce8ed","fog":"#8d9aa0","fogD":2000,"objects":[{"p":[0,-10,0],"s":[100,10,100]}],"spawns":[[0,0,0,0,0,0]]}';
module.exports.mobileControlPositions = {
  mobileJoystick: {
    left: 0.2,
    top: 0.69,
  },
  mobileJump: {
    top: 0.5,
    right: 0.02,
  },
  mobileCrouch: {
    top: 0.82,
    right: 0.15,
  },
  mobileEsc: {
    left: 0.18,
    top: 0.01,
  },
  mobileShoot: {
    left: 0.03,
    top: 0.28,
  },
  mobileAimShoot: {
    top: 0.56,
    right: 0.13,
  },
  mobileScope: {
    top: 0.35,
    right: 0.11,
  },
  mobileReload: {
    top: 0.73,
    right: 0.27,
  },
  mobileSwap: {
    left: 0,
    top: 0.85,
    right: 0,
  },
};

// Backfilled keys from the deobfuscated 1.js config surface so older
// social/editor/client paths can read expected properties.
module.exports.gameVersion = "3.7.2";
module.exports.editorVersion = "0.9.4";
module.exports.isFaceIT = module.exports.isComp;
module.exports.raidsInPubs = false;
module.exports.raidMapId = 12;
module.exports.kpdAutoTime = 60000;
module.exports.kpdWatchTime = 10000;
module.exports.getMaxKPDCalls = function (account) {
  const rating = account && Number(account.jobRating);
  const positives = account && Number(account.jobRatingPos);
  const ratio = rating > 0 ? positives / rating : 0;
  if (rating > 100 && ratio > 0.9) return 100;
  if (rating > 50 && ratio > 0.9) return 50;
  if (rating > 30 && ratio > 0.9) return 40;
  if (rating > 10 && ratio > 0.9) return 25;
  return 20;
};
module.exports.kpdTabs = [{ n: "Active Calls" }, { n: "Ban Logs" }];
module.exports.editorURL = module.exports.isProd
  ? "https://editor.krunker.io"
  : "http://127.0.0.1:6767/editor";
module.exports.bannedUsers = [...(module.exports.buM9 || [])];
module.exports.rewardUpdate = 1200000;
module.exports.maxSpdRChck = 6;
module.exports.challModeLvl = 30;
module.exports.thrdPY = 2;
module.exports.hostTypes = [
  { title: "Custom Server Setup" },
  {
    title: "Comp Server Setup",
    info: "Host a Comp Server with default competitive settings.",
    comp: true,
    noCustM: true,
  },
  {
    title: "Buy Dedicated Server",
    info: "Host a Dedicated Server that persists through updates.",
    comSoon: true,
    buyServ: true,
    noCustM: true,
  },
];
module.exports.serverTabs = ["Official Servers", "&nbsp;Custom Servers&nbsp;"];
module.exports.serverUpg = [
  { name: "40 Player Server", varN: "maxPS", cost: 1000 },
  { name: "Promote Server", varN: "promServ", cost: 2500 },
];
module.exports.teamLimit = 5;
module.exports.custGUITypes = [
  "Box",
  "Text",
  "Image",
  "Player Value (Text)",
  "Custom Value (Text)",
];
module.exports.guiLimit = 20;
module.exports.guiLimitP = 30;
module.exports.guiLimitF = 40;
module.exports.anchorLimit = 1000;
module.exports.triggerActionLimit = 5;
module.exports.classConfig = module.exports.gameConfig;
module.exports.playerVals = ["health", "maxHealth", "score"];
module.exports.custValLimit = 20;
module.exports.freeSpinId = 72;
module.exports.freeSpinURLS = [
  "https://www.youtube.com/channel/UClVkmDbH8yIX6J4XpjYu7Jg",
];
module.exports.buildMax = 1200;
module.exports.throwCharge = 800;
module.exports.clipNames = [
  "Idle",
  "Move",
  "MoveFast",
  "Jump",
  "Melee",
  "Shoot",
  "Crouch",
];
module.exports.pickupTimer = 1000;
module.exports.minZoneHeight = 100;
module.exports.maxZoneHeight = 10000;
module.exports.pathTypes = ["Loop", "Do Once", "Ping Pong", "Random"];
module.exports.vehicleLimit = 20;
module.exports.assetIcon = 100;
module.exports.illumTesel = 10;
module.exports.maxSegs = 40;
module.exports.illumMO = {
  1: 0.9,
  4: 0.8,
  7: 0.9,
  10: 0.85,
  13: 0.9,
};
module.exports.esportNews = [
  "Progress is being made on the Ranked Rework.",
  "We are partnering with FaceIT to improve ranked.",
  "Weekly sponsored tournaments are planned to return.",
];
module.exports.scrimServs = [
  { n: "NA", url: "https://discord.gg/D9ewATs" },
  { n: "EU", url: "https://discord.gg/k6TR9hT" },
  { n: "OCE", url: "https://discord.gg/sW53t46" },
  { n: "Asia", url: "https://discord.gg/2wX5hDWCTC" },
  { n: "India", url: "https://discord.gg/ERgdmVnj8U" },
  { n: "Africa", url: "https://discord.gg/NjS4k2d93x" },
];
module.exports.esportsTabs = [
  { n: "Pickups" },
  { n: "Ranked" },
  { n: "Scrim Servers" },
];
module.exports.marketFee = 0.1;
module.exports.giftFee = 0.1;
module.exports.twitchLinking = true;
module.exports.clanWarTime = 14400000;
module.exports.accValidationTime = 60000;
module.exports.ktvTimer = 120000;
module.exports.cssBypass = [
  "DukeV",
  "Sidney",
  "Tehchy",
  "Vince",
  "QuackyTTV",
  "0.o",
];
module.exports.tutorials = [
  { name: "Editor Basics", code: "Ewtb2rBvg9g" },
  { name: "Basic Controls", code: "1_HixIbbCM0" },
  { name: "Promotion", code: "SxGLXklICb8" },
  { name: "Common Issues", code: "0nT8kdpAi7g" },
  { name: "Importing Models", code: "E8JWupugj4s" },
  { name: "Testing & Hosting", code: "SxM2684Us5I" },
  { name: "Groups & Prefabs", code: "qPR7EuWXM3A" },
];
module.exports.tipsAndTricks = [
  { name: "Decals", code: "36-oUcgoyd4" },
  { name: "Slippery Ice Effect", code: "hc4qZD0fJYk" },
  { name: "Fake Mirror", code: "yVjZGsy74Ao" },
  { name: "Better Glass", code: "EOaVlaOmgLw" },
  { name: "Texture Merging", code: "4DuWCrdt_6Y" },
  { name: "Moving Water", code: "nMoz5AtCXkM" },
];
module.exports.twitchEvents = [
  {
    name: "#FORTHEKIDS Charity Event",
    time: {
      start: "March 6, 2021 9:00 AM UTC",
      end: "March 7, 2021 11:00 AM UTC",
    },
    drops: [
      2898, 2899, 2900, 2901, 2902, 2903, 2904, 2905, 2906, 2907, 2908, 2909,
    ],
  },
];
